import type { CampaignClass } from '.';
import type { ITTDCampaignAttributes } from './ttd_base';
import { TTDCampaign } from './ttd_base';

// Pixl Plus
export interface IOmniCampaignAttributes extends ITTDCampaignAttributes {
  readonly _cls: CampaignClass.Omni;
}

export class OmniCampaign extends TTDCampaign<IOmniCampaignAttributes> {}
